import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { useApi } from "@/lib/api";
import { useMe } from "@/components/portal/MeContext";
import { ProjectCard } from "@/components/portal/ProjectCard";
import { ProjectForm } from "@/components/portal/ProjectForm";
import { PageHeader, Empty } from "@/components/portal/StatusBadge";

export default function Projects() {
  const api = useApi();
  const me = useMe();
  const [projects, setProjects] = useState(null);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("all");
  useEffect(() => {
    api("get", "/projects").then(setProjects);
  }, [api]);

  const shown = (projects || []).filter((p) => filter === "all" || p.status === filter);
  return (
    <div data-testid="projects-page">
      <PageHeader eyebrow="Project management" title="Projects">
        {me.role === "admin" && (
          <button onClick={() => setOpen(true)} data-testid="new-project-btn" className="inline-flex items-center gap-2 rounded-full bg-[#F2B91C] px-5 py-2.5 text-sm font-semibold text-[#0E1F3F] hover:bg-[#D9A30F]"><Plus size={16} />New project</button>
        )}
      </PageHeader>
      <div className="mb-6 flex flex-wrap gap-2">
        {["all", "planning", "in_progress", "on_hold", "completed"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`filter-${s}`} className={`rounded-full border px-3.5 py-1.5 text-xs font-semibold capitalize transition-colors ${filter === s ? "border-[#0E1F3F] bg-[#0E1F3F] text-white" : "border-[#E6E2DA] bg-white hover:border-[#0E1F3F]"}`}>{s.replace("_", " ")}</button>
        ))}
      </div>
      {projects && (shown.length ? <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{shown.map((p) => <ProjectCard key={p.id} p={p} />)}</div> : <Empty text="No projects here yet." />)}
      <ProjectForm open={open} onOpenChange={setOpen} onSaved={(p) => setProjects([p, ...(projects || [])])} />
    </div>
  );
}
